import { z } from 'zod'

import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { isEmpty, optional, required } from './schemaHelpers'

const language = cap.language.state || 'IT'
const t = translations[language]

const MSG = t.gfCampoObbligatorio

export const buildTrainServiceSchema = ({ enableArrivoEntro = true } = {}) =>
  z
    .object({
      typeTrip: required(),
      departureDate: required(),
      trainCityDeparture: required(),
      trainCityArrival: required(),
      fromHourDeparture: optional(),
      toHourDeparture: enableArrivoEntro ? optional() : z.any().optional(),
      trainStationDeparture: optional(),
      trainStationDepartureDyn: optional(),
      arrivalDate: optional(),
      fromHourReturn: optional(),
      trainStationArrival: optional(),
      trainStationArrivalDyn: optional(),
      toHourReturn: enableArrivoEntro ? optional() : z.any().optional(),
      companyName: optional(),
      classType: optional(),
      seatPreference: optional(),
      noteAggiuntive: optional(),
      withinHoursDeparture: z.any().optional(),
      skipTrainSearch: z.any().optional(),
      carnet: z.any().optional()
    })
    .superRefine((data, ctx) => {
      const isRT = data.typeTrip === 'RT'
      const withinHours = !!data.withinHoursDeparture
      const skipSearch = !!data.skipTrainSearch

      if (!withinHours && isEmpty(data.fromHourDeparture)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['fromHourDeparture'], message: MSG })
      }
      if (isRT && isEmpty(data.arrivalDate)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['arrivalDate'], message: MSG })
      }
      if (isRT && isEmpty(data.fromHourReturn)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['fromHourReturn'], message: MSG })
      }
      if (!skipSearch) {
        if (isEmpty(data.trainStationDepartureDyn)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['trainStationDepartureDyn'],
            message: MSG
          })
        }
        if (isEmpty(data.trainStationArrivalDyn)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['trainStationArrivalDyn'],
            message: MSG
          })
        }
      }
    })
